import { addMilliseconds, minutesToMilliseconds } from 'date-fns';
import { LoadingState } from '../types';
function createFetchedData(loadingStateOrPayload, cacheDuration) {
    if (isNonSuccessLoadingState(loadingStateOrPayload)) {
        return { loadingState: loadingStateOrPayload };
    }
    const cacheDurationInMilliseconds = minutesToMilliseconds(cacheDuration);
    return {
        loadingState: LoadingState.Success,
        payload: loadingStateOrPayload,
        expiresAt: addMilliseconds(new Date(), cacheDurationInMilliseconds).toISOString()
    };
}
export { createFetchedData };
const isNonSuccessLoadingState = (data) => {
    if (typeof data !== 'string') {
        return false;
    }
    return data === LoadingState.NotLoaded || data === LoadingState.Loading || data === LoadingState.Failure;
};
//# sourceMappingURL=create-fetched-data.js.map